import { Claim, claimSubmit } from '../../../../../claim';
import { ReduxThunkAction } from '../../../../../redux/redux-actions';
import {
    FormDetails,
    getPolicyholderFromClaim,
    getLifeAssuredFromClaim,
    getClaimantFromClaim,
    getClaimInformationFromClaim,
    getPaymentFromClaim,
    getDeclarationFromClaim,
} from '../form-details-reducer';

type UpdateFormDetailsReturn = Promise<any>;
export type UpdateFormDetails = (
    formDetails: FormDetails | FormDetails[]
) => UpdateFormDetailsReturn;
type UpdateFormDetailsAction = (
    formDetails: FormDetails | FormDetails[]
) => ReduxThunkAction<UpdateFormDetailsReturn>;

export const updateFormDetailsAction: UpdateFormDetailsAction = (
    formDetails: FormDetails | FormDetails[]
) => {
    return async (dispatch, getState) => {
        if (Array.isArray(formDetails)) {
            const promises = formDetails.map(details => {
                return claimSubmit(dispatch, getState, getUpdatedClaim(details));
            });

            return Promise.all(promises);
        } else {
            return claimSubmit(dispatch, getState, getUpdatedClaim(formDetails));
        }
    };
};

function getUpdatedClaim(formDetails: FormDetails): (claim: Claim) => Claim {
    return (claim: Claim) => {
        const currentPolicyholder = getPolicyholderFromClaim(claim);
        const currentLifeAssured = getLifeAssuredFromClaim(claim);
        const currentClaimant = getClaimantFromClaim(claim);
        const currentClaimInformation = getClaimInformationFromClaim(claim);
        const currentPayment = getPaymentFromClaim(claim);
        const currentDeclaration = getDeclarationFromClaim(claim);

        return {
            ...claim,
            policyholder: {
                ...currentPolicyholder,
                ...formDetails.policyholder,
                individual: {
                    ...currentPolicyholder?.individual,
                    ...formDetails.policyholder?.individual,
                    addressDetails: {
                        ...currentPolicyholder?.individual?.addressDetails,
                        ...formDetails.policyholder?.individual?.addressDetails,
                    },
                    personalDetails: {
                        ...currentPolicyholder?.individual?.personalDetails,
                        ...formDetails.policyholder?.individual?.personalDetails,
                    },
                    employmentDetails: {
                        ...currentPolicyholder?.individual?.employmentDetails,
                        ...formDetails.policyholder?.individual?.employmentDetails,
                    },
                    companyDetails: {
                        ...currentPolicyholder?.individual?.companyDetails,
                        ...formDetails.policyholder?.individual?.companyDetails,
                    },
                },
            },
            lifeAssured: {
                ...currentLifeAssured,
                ...formDetails.lifeAssured,
                addressDetails: {
                    ...currentLifeAssured?.addressDetails,
                    ...formDetails.lifeAssured?.addressDetails,
                },
                PersonalDetails: {
                    ...currentLifeAssured?.personalDetails,
                    ...formDetails.lifeAssured?.personalDetails,
                },
                medicalAidDetails: {
                    ...currentLifeAssured?.medicalAidDetails,
                    ...formDetails.lifeAssured?.medicalAidDetails,
                },
                incomeProtectorClaimConditions: {
                    ...currentLifeAssured?.incomeProtectorClaimConditions,
                    ...formDetails.lifeAssured?.incomeProtectorClaimConditions,
                    doctorVisits:
                        formDetails.lifeAssured?.incomeProtectorClaimConditions?.doctorVisits ||
                        currentLifeAssured?.incomeProtectorClaimConditions?.doctorVisits,
                    medicalEvidenceOrReports:
                        formDetails.lifeAssured?.incomeProtectorClaimConditions
                            ?.medicalEvidenceOrReports ||
                        currentLifeAssured?.incomeProtectorClaimConditions
                            ?.medicalEvidenceOrReports,
                },
                otherInformation: {
                    ...currentLifeAssured?.otherInformation,
                    ...formDetails.lifeAssured?.otherInformation,
                },
                incomeDetails: {
                    ...currentLifeAssured?.incomeDetails,
                    ...formDetails.lifeAssured?.incomeDetails,
                },
            },
            claimant: {
                ...currentClaimant,
                ...formDetails.claimant,
                claimantDetails: {
                    ...currentClaimant?.claimantDetails,
                    ...formDetails.claimant?.claimantDetails,
                },
            },
            claimInformation: {
                ...currentClaimInformation,
                ...formDetails.claimInformation,
                occupationalDisabilityOverheadOne: {
                    ...currentClaimInformation?.occupationalDisabilityOverheadOne,
                    ...formDetails.claimInformation?.occupationalDisabilityOverheadOne,
                },
                occupationalDisabilityOverheadTwo:
                    formDetails.claimInformation?.occupationalDisabilityOverheadTwo ||
                    currentClaimInformation?.occupationalDisabilityOverheadTwo,
                detailsOfInabilityToPerformOccupation: {
                    ...currentClaimInformation?.detailsOfInabilityToPerformOccupation,
                    ...formDetails.claimInformation?.detailsOfInabilityToPerformOccupation,
                    sourcesOfIncome:
                        formDetails.claimInformation?.detailsOfInabilityToPerformOccupation
                            ?.sourcesOfIncome ||
                        currentClaimInformation?.detailsOfInabilityToPerformOccupation
                            ?.sourcesOfIncome,
                },
                otherBenefits: {
                    ...currentClaimInformation?.otherBenefits,
                    ...formDetails.claimInformation?.otherBenefits,
                    benefitDetails:
                        formDetails.claimInformation?.otherBenefits?.benefitDetails ||
                        currentClaimInformation?.otherBenefits?.benefitDetails,
                },
            },
            Payment: {
                ...currentPayment,
                ...formDetails.payment,
                PaymentInformation: {
                    ...currentPayment?.PaymentInformation,
                    ...formDetails.payment?.PaymentInformation,
                },
            },
            declaration: {
                ...currentDeclaration,
                ...formDetails.declaration,
            },
        };
    };
}
